export enum plaidServiceErrors {
  InstitutionAlreadyConnected = 'InstitutionAlreadyConnected',
}
